(function () {
  var wrappers = document.querySelectorAll("[data-predictive-search]");
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var input = wrapper.querySelector("[data-search-input]");
    var output = wrapper.querySelector("[data-search-results]");
    if (!input || !output) return;
    var outputId = "kp-search-results-" + Math.random().toString(36).slice(2, 9);
    output.id = outputId;
    output.setAttribute("role", "listbox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-controls", outputId);
    input.setAttribute("aria-expanded", "false");

    var controller = null;
    var debounceTimer = null;

    function clearResults() {
      output.innerHTML = "";
      output.hidden = true;
      input.setAttribute("aria-expanded", "false");
    }

    input.addEventListener("input", function (event) {
      var query = event.target.value.trim();
      clearTimeout(debounceTimer);

      if (!query || query.length < 2) {
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();

        var url =
          "/search/suggest.json?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product&resources[limit]=6";

        fetch(url, {
          signal: controller.signal,
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var products =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products
                ? data.resources.results.products
                : [];

            if (!products.length) {
              output.innerHTML = '<p class="kp-search-empty">No products found.</p>';
              output.hidden = false;
              input.setAttribute("aria-expanded", "true");
              return;
            }

            var html = products
              .map(function (product) {
                return (
                  '<a class="kp-search-item" href="' +
                  product.url +
                  '">' +
                  '<span class="kp-search-item__title">' +
                  product.title +
                  "</span>" +
                  '<span class="kp-search-item__price">' +
                  (product.price || "") +
                  "</span>" +
                  "</a>"
                );
              })
              .join("");

            output.innerHTML = html;
            output.hidden = false;
            input.setAttribute("aria-expanded", "true");
          })
          .catch(function () {
            clearResults();
          });
      }, 180);
    });

    document.addEventListener("click", function (event) {
      if (!wrapper.contains(event.target)) clearResults();
    });

    input.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        clearResults();
      }
    });
  });
})();
